import React from 'react'
type propsSide = {
    isActive: boolean,
    [key: string]: unknown;
}

export const SideD = ({ isActive, ...props }: propsSide) => {
    let colorSide: string = `#EDEAE2`
    if (isActive) colorSide = `#425D76`

    let colorText: string = `#BBB5AA`
    if (isActive) colorText = `#040503`

    return (
        <svg width="77" height="83" viewBox="0 0 77 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76 50.4083L61.1293 65.8083H1V31.8L15.8707 16.4L45.2888 1L76 16.4V50.4083Z" fill="white" />
            <path d="M15.8707 16.3999L1 31.7999V65.8082L15.8707 50.4082V16.3999Z" fill={colorSide} stroke={colorText} stroke-linejoin="round" />
            <path d="M15.8707 50.4083V16.4069L45.2888 1L76 16.4069V50.4083H15.8707Z" stroke={colorText} />
            <path d="M76 16.3999L61.1293 32.1207V65.8082L76 50.4082V16.3999Z" stroke={colorText} stroke-linejoin="round" />
            <path d="M1 65.8082V31.8068L30.4181 16.3999L61.1293 31.8068V65.8082H1Z" stroke={colorText} />
            <path d="M30.4181 16.4L45.6121 1" stroke={colorText} />
            <path d="M35.8585 82.8083V72.1443H38.8688C39.7965 72.1443 40.6168 72.3494 41.3297 72.7595C42.0426 73.1697 42.5919 73.7532 42.9777 74.51C43.3683 75.2668 43.566 76.136 43.5709 77.1174V77.7986C43.5709 78.8044 43.3756 79.6858 42.985 80.4426C42.5992 81.1995 42.045 81.7805 41.3224 82.1858C40.6046 82.5911 39.7672 82.7986 38.8102 82.8083H35.8585ZM37.2648 73.3015V81.6584H38.7443C39.8282 81.6584 40.6705 81.3215 41.2711 80.6477C41.8766 79.9739 42.1793 79.0144 42.1793 77.7693V77.1467C42.1793 75.9358 41.8937 74.9958 41.3224 74.3269C40.756 73.6531 39.9503 73.3113 38.9054 73.3015H37.2648Z" fill={colorText} />
        </svg>


    )
}
